<template>
    <div class="list-empty">
        <img src="../../../assets/icon/ic_nodata.svg">
        <p>{{lbl.text_nodata}}</p>
    </div>
</template>
<script>
export default {
    name: 'EmptyList',
    props:{
        lbl: Object,
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
.list-empty{
    @include content-nodata();
}
</style>
